import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Typography } from '@mui/material';
//
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart'
import { useTheme } from '@mui/material/styles';

var pt = require("apexcharts/dist/locales/pt.json");

const CHART_DATA = [
    {
    name: '<div style="text-align: center;"> <div style="display: inline-block; vertical-align: middle;">1</div> <img style="display: inline-block; vertical-align: middle;"src="/static/star.svg"/></div>',
    type: 'area',
    data: [4,3,6,2,5,4,3,5,3,5]
    },
  {
    name: '<div style="text-align: center;"> <div style="display: inline-block; vertical-align: middle;">2</div> <img style="display: inline-block; vertical-align: middle;"src="/static/star.svg"/></div>',
    type: 'area',
    data: [9,5,5,3,3,5,7,6,4,6]
  },
  {
    name: '<div style="text-align: center;"> <div style="display: inline-block; vertical-align: middle;">3</div> <img style="display: inline-block; vertical-align: middle;"src="/static/star.svg"/></div>',
    type: 'area',
    data: [3,8,7,8,10,5,7,6,2,3]
  },
  {
    name: '<div style="text-align: center;"> <div style="display: inline-block; vertical-align: middle;">4</div> <img style="display: inline-block; vertical-align: middle;"src="/static/star.svg"/></div>',
    type: 'area',
    data: [5,4,3,21,14,31,21,22,24,20]
  },
  {
    name: '<div style="text-align: center;"> <div style="display: inline-block; vertical-align: middle;">5</div> <img style="display: inline-block; vertical-align: middle;"src="/static/star.svg"/></div>',
    type: 'area',
    data: [10,6,3,8,10,15,17,16,12,13]
  },
];

export default function SatisfacaoExercicios() {
    const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      locales: [pt],
      defaultLocale: 'pt',
    },
    colors: [
        theme.palette.error.dark,
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.primary.main,
        theme.palette.primary.dark
      ],
    stroke: { 
      width: [3,2.5,2,2.5,3],
      curve: 'smooth'
    },
    plotOptions: { 
      bar: { columnWidth: '11%', borderRadius: 4 } 
    },
    fill: { 
      type: 'gradient',
    },
    labels: [
      '01/01/2021',
      '02/01/2021',
      '03/01/2021',
      '04/01/2021',
      '05/01/2021',
      '06/01/2021',
      '07/01/2021',
      '08/01/2021',
      '09/01/2021',
      '10/01/2021',
      '11/01/2021'
    ],
    xaxis: { 
      type: 'datetime' 
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} Avaliações`; // write something
          }
          return y;
        }
      }
    }
  });

  return (
    
    <Typography variant="h6">Satisfação
    <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={250} />
    </Typography>
   

  );
}
